import { StyledText } from '@clickcease/cc-client-components-lib'
import { useTranslation } from 'react-i18next'

import { WrapperWithButtons } from '../../../../../../../components/Elements/WrapperWithButtons/WrapperWithButtons'
import React from 'react'

interface ConfirmNoAdSetsProps {
  onBack: () => void
  onConfirm: () => void
  isBackDisabled?: boolean
}

export const ConfirmNoAdSets = ({ onBack, onConfirm, isBackDisabled }: ConfirmNoAdSetsProps) => {
  const { t } = useTranslation('PMPlatforms')
  return (
    <WrapperWithButtons
      onGhostButtonClick={onBack}
      ghostButtonText={t('meta-connection-wizard.back-button')}
      onPrimaryButtonClick={onConfirm}
      primaryButtonText={t('meta-connection-wizard.approve')}
      isGhostButtonDisabled={isBackDisabled}
    >
      <StyledText variant={'baseLight'}>
        {t('meta-connection-wizard.confirm-no-adsets-explainer')}
      </StyledText>
    </WrapperWithButtons>
  )
}
